
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import { intro_bg } from '../../index.const';

export default class LoginController {
    constructor($rootScope, $log, $state, $timeout, $interval, Session, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Session = Session;
        this.Dialog = Dialog;
        this.intro_bg = intro_bg;
        this.$timeout = $timeout;
        this.$interval = $interval;

        this.state = {
            step: 0
        }

        this.credits = 0;
    }

    $onInit(){
        let data = this.Session.get();
        
        if (!_.isEmpty(data)){
            this.$state.go("main");
        }

        this.intro = [
        {bg: this.intro_bg[4], dialog: "Nossa! <br/>O que é isso?", direction: 'in'},
        {bg: this.intro_bg[3], dialog: "Olá, humano! Dentro desse <strong>tetraedro</strong> <br/> há um cristal que pode ser utilizado <br/>para visitar o <strong>planeta Tetrix</strong>.", direction: 'out'},
        {bg: this.intro_bg[3], dialog: "Mas ele precisa ser aberto!", direction: 'out'},
        {bg: this.intro_bg[5], dialog: "Entre seus brinquedos foram deixadas <strong>3 chaves</strong>.", direction: 'out'},
        {bg: this.intro_bg[5], dialog: "Mas para ganhá-las você deve cumprir cada um dos <strong>desafios</strong>.<br/> Utilize as chaves para abrir o tetraedro.", direction: 'out'},
        {bg: this.intro_bg[3], dialog: "Além disso, ao realizar os <strong>desafios</strong> você irá adquirir <strong>habilidades</strong>.", direction: 'out'},
        {bg: this.intro_bg[3], dialog: "Essas <strong>habilidades</strong> são muito importantes para sobreviver no <strong>Planeta Tetrix</strong>.", direction: 'out'},
        {bg: this.intro_bg[3], dialog: "Até mais e <strong>divirta-se</strong>!", direction: 'out'}
        ]
    }

    hasDialog(val){
        if(val !== false)
            return true;
        else
            return false;
    }

    showIntro() {
        this.state.step = 1;
    }

    nextStep() {
        if (this.state.step < this.intro.length) {
            this.state.step++;
        } else {
            this.Session.create();
            this.$state.go("main");
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/login/login.controller.js